import { render, staticRenderFns } from "./TelefonNumarasiGuncelleme.vue?vue&type=template&id=37f3d680&scoped=true"
import script from "./TelefonNumarasiGuncelleme.vue?vue&type=script&lang=js"
export * from "./TelefonNumarasiGuncelleme.vue?vue&type=script&lang=js"
import style0 from "./TelefonNumarasiGuncelleme.vue?vue&type=style&index=0&id=37f3d680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3d680",
  null
  
)

export default component.exports